import { useMemo } from 'react';

import { TextWithLinks } from '@/components/TextWithLinks';
import { Tooltip } from '@/design-system';

export function LongContentTooltip({
  value,
  displayAsJSON,
}: {
  value: unknown;
  displayAsJSON?: boolean;
}) {
  const stringToDisplay =
    typeof value !== 'string' ? JSON.stringify(value) : value;

  const parsedValue = useMemo(() => {
    if (typeof value === 'string') {
      try {
        const val = JSON.parse(value);
        if (val && typeof val === 'object') {
          return JSON.stringify(val, null, 2);
        }
      } catch {
        // Do nothing
      }
    } else if (value && typeof value === 'object') {
      return JSON.stringify(value, null, 2);
    }
    return value;
  }, [value]);

  if (!parsedValue || typeof parsedValue !== 'string') return '';

  return (
    <Tooltip
      title={
        <div
          className="break-word"
          style={{
            maxWidth: '300px',
            maxHeight: '300px',
            overflow: 'auto',
            whiteSpace: 'pre-wrap',
            fontFamily: displayAsJSON ? 'monospace' : 'inherit',
            padding: '2px',
          }}
        >
          {parsedValue}
        </div>
      }
    >
      <div
        className="w-full truncate"
        style={{
          textAlign: 'left',
        }}
        aria-label="Show more information"
      >
        {<TextWithLinks text={stringToDisplay} />}
      </div>
    </Tooltip>
  );
}
